import { supabase } from '@/integrations/supabase/client';

export interface PendingRating {
  negotiation_id: string;
  listing_title: string;
  listing_type: string;
  other_user_id: string;
  other_user_name: string;
  other_user_avatar: string | null;
  rating_role: 'buyer_to_seller' | 'seller_to_buyer';
  completed_at: string;
}

/**
 * Fetch pending ratings for the current user using the optimized RPC
 */
export async function fetchPendingRatingsRPC(): Promise<PendingRating[]> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return [];

  const { data, error } = await supabase.rpc('get_pending_ratings_for_user', {
    p_user_id: user.id
  });

  if (error) {
    console.error('Error fetching pending ratings:', error);
    return [];
  }

  return (data || []).map((item: any) => ({
    negotiation_id: item.negotiation_id,
    listing_title: item.listing_title,
    listing_type: item.listing_type,
    other_user_id: item.other_user_id,
    other_user_name: item.other_user_name || 'Usuário',
    other_user_avatar: item.other_user_avatar,
    rating_role: item.rating_role as 'buyer_to_seller' | 'seller_to_buyer',
    completed_at: item.completed_at,
  }));
}

export interface PublicFeedback {
  id: string;
  rating: number;
  comment: string;
  feedback_tags: string[];
  rating_role: string;
  created_at: string;
  listing_title: string;
  listing_type: string;
}

/**
 * Fetch public feedbacks for a user
 */
export async function fetchPublicFeedbacks(userId: string, limit: number = 5): Promise<PublicFeedback[]> {
  const { data, error } = await supabase.rpc('get_public_feedbacks_for_user', {
    p_user_id: userId,
    p_limit: limit
  });

  if (error) {
    console.error('Error fetching public feedbacks:', error);
    return [];
  }

  return (data || []) as PublicFeedback[];
}
